var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("z-lead", { staticClass: "u-bottom-margin--m" }, [
          _vm._v(_vm._s(_vm.text.lead)),
        ]),
        _vm._v(" "),
        _c("z-figure", {
          staticClass: "team__figure",
          attrs: { caption: _vm.text.caption, image: "/images/team/team.jpg" },
        }),
        _vm._v(" "),
        this.lang === "ru"
          ? _c(
              "z-video",
              {
                staticClass: "team__video",
                attrs: {
                  src: "https://files.raspadskaya.com/files/video.mp4",
                  poster: "/images/team/preview_video.png",
                },
              },
              [_vm._v("]\n        ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.teamInfo.items && _vm.teamInfo.items.length
          ? [
              _c(
                "z-caption",
                {
                  staticClass: "team__title",
                  attrs: { tag: "h2", size: "2xl" },
                },
                [_vm._v(_vm._s(_vm.text.main))]
              ),
              _vm._v(" "),
              _vm._l(_vm.teamInfo.items, function (person, index) {
                return _c(
                  "a",
                  {
                    key: index,
                    staticClass: "team__link col-default-12",
                    attrs: { href: person.detailPageUrl || "" },
                  },
                  [
                    _c("z-blockquote", {
                      attrs: {
                        link: "",
                        size: "s",
                        author: {
                          name: person.name,
                          info: person.position.value,
                          photo: person.previewPicture.link || "",
                        },
                        text: person.quote.value,
                        date: person.startOfWork.value,
                        linkToDetail: person.detailPageUrl || "",
                      },
                    }),
                  ],
                  1
                )
              }),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }